// Copyright (c) 2025 WiseTime. All rights reserved.

import { isDevelopmentEnv } from "../app/config"

/* eslint-disable lingui/no-unlocalized-strings */

/**
 * Handles ResizeObserver error workaround for react-virtuoso and react-beautiful-dnd compatibility
 * https://virtuoso.dev/react-beautiful-dnd/
 * https://github.com/DevExpress/testcafe/issues/4857#issuecomment-598775956
 * https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
 */
export const handleResizeObserverError = (e: ErrorEvent): void => {
  const resizeObserverLoopLimitMessage = "ResizeObserver loop limit exceeded"
  const resizeObserverUndeliveredNotifications = "ResizeObserver loop completed with undelivered notifications."
  
  if (
    e.message === resizeObserverUndeliveredNotifications ||
    e.message === resizeObserverLoopLimitMessage
  ) {
    // react-virtuoso resize observer can throw this error,
    // which is caught by react-beautiful-dnd and aborts dragging.
    e.stopImmediatePropagation()
  }
  
  if (isDevelopmentEnv() && (
    e.message === resizeObserverUndeliveredNotifications ||
    e.message === resizeObserverLoopLimitMessage
  )) {
    const resizeObserverErr = document.getElementById(
      "webpack-dev-server-client-overlay"
    )
    if (resizeObserverErr) {
      // eslint-disable-next-line lingui/no-unlocalized-strings
      resizeObserverErr.setAttribute("style", "display: none")
    }
  }
}
